import React from 'react';
import { mrg } from '../../common/util';
import { Empty } from 'antd';
import g from '../../styles/global';

const styles = {
  full: {
    width: '100%',
    height: '100%',
    padding: g.global.baseline
  }
};

function NoData(props) {
  const style = props && props.style ? props.style : {};
  return (
    <div
      style={mrg([
        styles.full,
        g.layout.flexVertical,
        g.layout.flexCenter,
        g.layout.alignCenter,
        style,
        { height: 'auto' }
      ])}
    >
      <Empty description={props?.text || 'No Data'} />
    </div>
  );
}

export default NoData;
